import { IPage, ISpace, ISpaceRoute } from '@typedream/data';
import { Dispatch, PropsWithChildren, ReactNode, SetStateAction } from 'react';

export interface ISidebarContext {
  children: ReactNode;
  open?: boolean;
}

export interface MenuPagesProps {
  enableEmpty?: boolean;
  enableDelete?: boolean;
}

export type PagesTreeItemHomeProps = {
  route: ISpaceRoute;
  path: string[]; // path includes the current page as the last slug
  pages: { [id: string]: IPage };
  space: ISpace;
  pageID: string;
  onOpenOptions: (pageID: string) => void;
  openPage: (path: string) => void;
};

export type PagesTreeItemProps = {
  route: ISpaceRoute;
  path: string[];
  pages: { [id: string]: IPage };
  space: ISpace;
  pKey: string;
  pageID: string;
  pageIDPath: string[];
  isRoot?: boolean;
  onOpenOptions: (pageID: string) => void;
  onCreate: (
    route: ISpaceRoute,
    pagePath: string[],
    setopen: Dispatch<SetStateAction<boolean>>
  ) => void;
  openPage: (path: string) => void;
};

export interface DragItemPage {
  path: string[];
  type: string;
}

export enum DROP {
  INSIDE = 'INSIDE',
  TOP = 'TOP',
  BOTTOM = 'BOTTOM',
}

export const PAGE_TYPE = 'PAGE';

export type PagesDnDWrapperProps = PropsWithChildren<{
  space: ISpace;
  path: string[];
  setdropDirection: Dispatch<SetStateAction<DROP | null>>;
  setisOverCurrent: Dispatch<SetStateAction<boolean>>;
  open: boolean;
  setopen: Dispatch<SetStateAction<boolean>>;
  pageTreeRole: 'root-page' | 'child-page';
}>;
